/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';
import { DELETE_DEVICE_ID_PERSONA } from '../actions/PersonaServiceActions';
import type { PersonaServiceReducer } from '../types/personaServiceTypes';
import '../types/personaServiceTypes';
export function createInitialState(): PersonaServiceReducer {
  return {
    loadingStatus: LOADING_STATUS.init,
    error: null,
    data: [],
  };
}
const INIT_STATE = createInitialState();

function Handler(state: PersonaServiceReducer = INIT_STATE, action) {
  switch (action.type) {
    case DELETE_DEVICE_ID_PERSONA.response:
      return { ...state, loadingStatus: LOADING_STATUS.LOADED, data: action.data };

    default:
      return state;
  }
}

const PersonaService = reducerWrapper(INIT_STATE, Handler, {
  request: [DELETE_DEVICE_ID_PERSONA],
  error: [DELETE_DEVICE_ID_PERSONA],
});
export default PersonaService;
